/**
 * Dashboard Controls - Panel de Control del Mapa GPS
 * Maneja filtros, búsqueda por placa y actualizaciones en tiempo real
 */

class DashboardControls {
  constructor() {
    this.selectedVehicle = null;
    this.updateInterval = null;
    this.timerInterval = null;
    this.currentTimer = 5; // segundos
    this.vehicles = [];
    this.vehicleStates = {
      parado: 0,
      sinCobertura: 0,
      excesoVelocidad: 0,
      transmisionNormal: 0,
      mantenimiento: 0
    };
    
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.startUpdateTimer();
    this.loadInitialData();
  }

  setupEventListeners() {
    // Filtros
    document.getElementById('empresa-filter')?.addEventListener('change', (e) => {
      this.onEmpresaChange(e.target.value);
    });

    document.getElementById('flota-filter')?.addEventListener('change', (e) => {
      this.onFlotaChange(e.target.value);
    });

    document.getElementById('vehiculo-filter')?.addEventListener('change', (e) => {
      this.onVehiculoChange(e.target.value);
    });

    // Búsqueda por placa
    document.getElementById('placa-search')?.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.searchVehicleByPlaca();
      }
    });
  }

  async loadInitialData() {
    try {
      // Cargar empresas
      await this.loadEmpresas();
      
      // Cargar vehículos iniciales
      await this.loadVehicles();
      
      // Actualizar contadores de estados
      this.updateVehicleStates();
      
    } catch (error) {
      console.error('Error loading initial data:', error);
    }
  }

  async loadEmpresas() {
    // Simular carga de empresas (reemplazar con API real)
    const empresas = [
      { id: '5465', nombre: 'A y P LOGISTI-K DEL PERU SAC' },
      { id: '1234', nombre: 'EMPRESA TRANSPORTE ABC' },
      { id: '5678', nombre: 'LOGISTICA PERU SAC' }
    ];

    const select = document.getElementById('empresa-filter');
    if (select) {
      select.innerHTML = '<option value="">Seleccionar Empresa</option>';
      empresas.forEach(empresa => {
        const option = document.createElement('option');
        option.value = empresa.id;
        option.textContent = empresa.nombre;
        select.appendChild(option);
      });
    }
  }

  async loadVehicles(empresaId = '', flotaId = '') {
    try {
      // Simular datos de vehículos (reemplazar con API real)
      this.vehicles = [
        {
          id: 'VH001',
          placa: 'A1F-833',
          chofer: 'ARZAPALO JUAN',
          ubicacion: 'Avenida Gregorio Escobedo, Jesús María, Lima',
          marca: 'VOLKSWAGEN',
          modelo: '15.190E',
          identificador: '357073296182625',
          chip: '989071465',
          telefono1: '',
          telefono2: '',
          telefono3: '',
          lat: -12.0464,
          lng: -77.0428,
          speed: 0,
          status: 'parado',
          lastUpdate: new Date(),
          flota: '1579',
          empresa: '5465'
        },
        {
          id: 'VH002',
          placa: 'B2G-444',
          chofer: 'GARCIA PEDRO',
          ubicacion: 'Av. Javier Prado, San Isidro, Lima',
          marca: 'FORD',
          modelo: 'Cargo 816',
          identificador: '357073296182626',
          chip: '989071466',
          telefono1: '987654321',
          telefono2: '',
          telefono3: '',
          lat: -12.0564,
          lng: -77.0328,
          speed: 45,
          status: 'transmisionNormal',
          lastUpdate: new Date(),
          flota: '1579',
          empresa: '5465'
        },
        {
          id: 'VH003',
          placa: 'C3H-555',
          chofer: 'LOPEZ MARIA',
          ubicacion: 'Av. Arequipa, Miraflores, Lima',
          marca: 'MERCEDES',
          modelo: 'Sprinter',
          identificador: '357073296182627',
          chip: '989071467',
          telefono1: '987654322',
          telefono2: '987654323',
          telefono3: '',
          lat: -12.0364,
          lng: -77.0528,
          speed: 95,
          status: 'excesoVelocidad',
          lastUpdate: new Date(),
          flota: '1579',
          empresa: '5465'
        }
      ];

      this.updateVehiculoFilter();
      this.updateVehicleStates();
      
    } catch (error) {
      console.error('Error loading vehicles:', error);
    }
  }

  updateVehiculoFilter() {
    const select = document.getElementById('vehiculo-filter');
    if (!select) return;

    const empresaId = document.getElementById('empresa-filter')?.value || '';
    const flotaId = document.getElementById('flota-filter')?.value || '';

    // Filtrar vehículos
    const filteredVehicles = this.vehicles.filter(vehicle => {
      if (empresaId && vehicle.empresa !== empresaId) return false;
      if (flotaId && vehicle.flota !== flotaId) return false;
      return true;
    });

    select.innerHTML = '<option value="">Seleccionar Vehículo</option>';
    filteredVehicles.forEach(vehicle => {
      const option = document.createElement('option');
      option.value = vehicle.id;
      option.textContent = `${vehicle.placa} - ${vehicle.chofer}`;
      select.appendChild(option);
    });
  }

  updateVehicleStates() {
    // Contar vehículos por estado
    this.vehicleStates = {
      parado: this.vehicles.filter(v => v.status === 'parado').length,
      sinCobertura: this.vehicles.filter(v => v.status === 'sinCobertura').length,
      excesoVelocidad: this.vehicles.filter(v => v.status === 'excesoVelocidad').length,
      transmisionNormal: this.vehicles.filter(v => v.status === 'transmisionNormal').length,
      mantenimiento: this.vehicles.filter(v => v.status === 'mantenimiento').length
    };

    // Actualizar contadores en la UI (solo si existen los elementos)
    const countParado = document.getElementById('count-parado');
    const countSinCobertura = document.getElementById('count-sin-cobertura');
    const countExcesoVelocidad = document.getElementById('count-exceso-velocidad');
    const countTransmisionNormal = document.getElementById('count-transmision-normal');
    const countMantenimiento = document.getElementById('count-mantenimiento');

    if (countParado) countParado.textContent = `(${this.vehicleStates.parado})`;
    if (countSinCobertura) countSinCobertura.textContent = `(${this.vehicleStates.sinCobertura})`;
    if (countExcesoVelocidad) countExcesoVelocidad.textContent = `(${this.vehicleStates.excesoVelocidad})`;
    if (countTransmisionNormal) countTransmisionNormal.textContent = `(${this.vehicleStates.transmisionNormal})`;
    if (countMantenimiento) countMantenimiento.textContent = `(${this.vehicleStates.mantenimiento})`;
  }

  onEmpresaChange(empresaId) {
    this.loadVehicles(empresaId);
  }

  onFlotaChange(flotaId) {
    this.loadVehicles('', flotaId);
  }

  onVehiculoChange(vehicleId) {
    if (!vehicleId) {
      this.clearVehicleInfo();
      return;
    }

    const vehicle = this.vehicles.find(v => v.id === vehicleId);
    if (vehicle) {
      this.showVehicleInfo(vehicle);
      this.centerMapOnVehicle(vehicle);
    }
  }

  async searchVehicleByPlaca() {
    const placa = document.getElementById('placa-search')?.value?.trim();
    if (!placa) {
      alert('Por favor ingresa una placa');
      return;
    }

    try {
      // Buscar vehículo por placa
      const vehicle = this.vehicles.find(v => 
        v.placa.toLowerCase().includes(placa.toLowerCase())
      );

      if (vehicle) {
        this.showVehicleInfo(vehicle);
        this.centerMapOnVehicle(vehicle);
        
        // Seleccionar en el dropdown
        const select = document.getElementById('vehiculo-filter');
        if (select) {
          select.value = vehicle.id;
        }
        
        // Limpiar búsqueda
        document.getElementById('placa-search').value = '';
        
      } else {
        alert(`Vehículo con placa "${placa}" no encontrado`);
      }
      
    } catch (error) {
      console.error('Error searching vehicle:', error);
      alert('Error al buscar el vehículo');
    }
  }

  showVehicleInfo(vehicle) {
    const container = document.getElementById('vehicle-info');
    if (!container) return;

    container.innerHTML = `
      <div class="vehicle-detail">
        <span class="detail-label">Chofer:</span>
        <span class="detail-value">${vehicle.chofer}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Ubicación:</span>
        <span class="detail-value">${vehicle.ubicacion}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Marca:</span>
        <span class="detail-value">${vehicle.marca}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Modelo:</span>
        <span class="detail-value">${vehicle.modelo}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Placa:</span>
        <span class="detail-value">${vehicle.placa} <span class="badge bg-primary">I P H</span></span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Identificador:</span>
        <span class="detail-value">${vehicle.identificador}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Chip:</span>
        <span class="detail-value">${vehicle.chip}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Teléfono1:</span>
        <span class="detail-value">${vehicle.telefono1 || 'N/A'}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Teléfono2:</span>
        <span class="detail-value">${vehicle.telefono2 || 'N/A'}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Teléfono3:</span>
        <span class="detail-value">${vehicle.telefono3 || 'N/A'}</span>
      </div>
      <div class="vehicle-detail">
        <span class="detail-label">Última Actualización:</span>
        <span class="detail-value">${vehicle.lastUpdate.toLocaleString()}</span>
      </div>
      <div class="vehicle-detail mT-10">
        <button class="btn btn-outline-primary btn-sm">
          <i class="ti-dashboard mR-5"></i>Kms
        </button>
      </div>
    `;

    this.selectedVehicle = vehicle;
  }

  clearVehicleInfo() {
    const container = document.getElementById('vehicle-info');
    if (container) {
      container.innerHTML = '<p class="c-grey-600 fsz-sm">Selecciona un vehículo para ver su información</p>';
    }
    this.selectedVehicle = null;
  }

  centerMapOnVehicle(vehicle) {
    // Obtener instancia del mapa desde el módulo Leaflet
    if (window.leafletMapInstance) {
      window.leafletMapInstance.setView([vehicle.lat, vehicle.lng], 15);
    }
  }

  startUpdateTimer() {
    this.timerInterval = setInterval(() => {
      this.currentTimer--;
      
      if (this.currentTimer <= 0) {
        this.currentTimer = 5;
        this.updateVehicleData();
      }
      
      this.updateTimerDisplay();
    }, 1000);
  }

  updateTimerDisplay() {
    const timerElement = document.getElementById('update-timer');
    if (timerElement) {
      const minutes = Math.floor(this.currentTimer / 60);
      const seconds = this.currentTimer % 60;
      timerElement.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:00`;
    }
  }

  async updateVehicleData() {
    try {
      // Simular actualización de datos (reemplazar con API real)
      this.vehicles.forEach(vehicle => {
        // Simular movimiento
        if (vehicle.status === 'transmisionNormal') {
          vehicle.lat += (Math.random() - 0.5) * 0.001;
          vehicle.lng += (Math.random() - 0.5) * 0.001;
          vehicle.speed = Math.floor(Math.random() * 80) + 10;
        }
        
        vehicle.lastUpdate = new Date();
      });

      // Actualizar contadores
      this.updateVehicleStates();
      
      // Actualizar información del vehículo seleccionado
      if (this.selectedVehicle) {
        const updatedVehicle = this.vehicles.find(v => v.id === this.selectedVehicle.id);
        if (updatedVehicle) {
          this.showVehicleInfo(updatedVehicle);
        }
      }
      
      // Notificar al mapa para actualizar marcadores
      if (window.leafletMapInstance && window.leafletMapInstance.updatePositions) {
        window.leafletMapInstance.updatePositions();
      }
      
    } catch (error) {
      console.error('Error updating vehicle data:', error);
    }
  }

  destroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  // Solo inicializar en la página principal del dashboard
  if (document.getElementById('count-parado') && document.getElementById('count-sin-cobertura')) {
    window.dashboardControls = new DashboardControls();
  }
});

// Función global para búsqueda por placa
window.searchVehicleByPlaca = function() {
  if (window.dashboardControls) {
    window.dashboardControls.searchVehicleByPlaca();
  }
};

export default DashboardControls;
